<template>
  <div class="component-list-paid-true">
    <!-- <app-loading :isFull="true" v-if="isLoading" /> -->
    <b-table stacked="lg" :fields="fieldsItems" :items="allAdjustment" class="font-14 text-center">
      <template v-slot:cell(deficits)="row" >
        <p class="mb-0" v-if="row.item.deficits">{{row.item.deficits | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>
      <template v-slot:cell(impure_earned)="row" >
        <p class="mb-0" v-if="row.item.impure_earned">{{row.item.impure_earned | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>
      <template v-slot:cell(pay_amount)="row" >
        <p class="mb-0" v-if="row.item.pay_amount">{{row.item.pay_amount | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>
      <template v-slot:cell(date)="row" >
        {{row.item.date | date}}
      </template>
      <template v-slot:cell(paid)="row" >
        <p class="mb-0">{{row.item.paid ? 'تسویه شده' : 'در حال بررسی' }}</p>
      </template>
      <template v-slot:cell(pay_amount)="row" >
        <p class="mb-0" v-if="row.item.pay_amount">{{row.item.pay_amount | currency}}</p>
        <p class="mb-0" v-else>0</p>
      </template>
      <template v-slot:cell(pay_mode)="row" >
        <p class="mb-0">{{row.item.pay_mode =='cash' ? 'نقدی' : 'الکترونیک'}}</p>
      </template>
      <template v-slot:cell(paid)="row" >
        <p class="mb-0">{{row.item.Paid | currency}}</p>
      </template>
    </b-table>
    <page-number :lengthList="lengthList" @callBack="getAllAdjustment" />
  </div>
</template>

<script>
export default {
  name: 'component-list-paid-true',
  data () {
    return {
      pay_mode: 'wallet',
      isLoading: false,
      isInstructor: false,
      fieldsItems: [
        { key: 'date', label: 'تاریخ',sortable: true },
        { key: 'fullname', label: 'نام کاربری' },
        { key: 'deficits', label: 'کسورات',sortable: true },
        { key: 'deficits_percent', label: 'درصد کسورات' ,sortable: true},
        { key: 'impure_earned', label: 'در آمد خالص',sortable: true },
        { key: 'msgs', label: 'پیغام' },
        { key: 'pay_amount', label: 'مبلغ پرداختی',sortable: true },
        { key: 'pay_mode', label: 'نحوه تسویه' }
      ],
      isModal: false,
      page: 1
    }
  },
  computed: {
    level () {
      return this.$store.state.auth.level
    },
    lengthList () {
      return this.$store.state.Daccounting.AllAdjustmentTrue.length
    },
    allAdjustment () {
      return this.$store.state.Daccounting.AllAdjustmentTrue
    }

  },
  async mounted () {
    this.isInstructor = await this.checkAccess(false)
    this.getAllAdjustment(1)
  },
  methods: {
    async getAllAdjustment (p) {
      this.isLoading = true
      await this.$store.dispatch('Daccounting/getAllAdjustmentTrue', { p })
      this.isLoading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard-component/my-payment/list-paid-true.vue